import { useBusEmitterListener } from "./index";

const outerObjectChangedEvent = Symbol("bridge:outerObjectChanged");

export const {
  emitter: outerObjectChanged,
  listener: onOuterObjectChanged,
} = useBusEmitterListener(outerObjectChangedEvent);
